<template>
  <nav class="sidebar bg-dark text-white d-flex flex-column p-3">
    <h4 class="text-center">MyApp</h4>
    <ul class="nav flex-column">
      <li class="nav-item">
        <router-link class="nav-link" to="/">Dashboard</router-link>
      </li>
      <li class="nav-item">
        <router-link v-if="isSuperAdmin" class="nav-link" :to="{ name: 'Distributors' }">Distributors</router-link>
      </li>
      <li class="nav-item">
        <router-link v-if="isSuperAdmin || isDistributor" class="nav-link" :to="{ name: 'Clients' }">Clients</router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link v-if="isSuperAdmin || isDistributor" class="nav-link" to="/licenses">Licenses</router-link>
      </li> -->
      <li class="nav-item">
        <router-link v-if="isSuperAdmin" class="nav-link" to="/users">Users</router-link>
      </li>
    </ul>
    <div class="mt-auto">
      <hr />
      <div class="text-center">
        <p class="small mb-1">Logged in as:</p>
        <strong>{{ authStore.user?.fullName }}</strong>
        <button @click="logout" class="btn btn-outline-light btn-sm w-100 mt-2">Logout</button>
      </div>
    </div>
  </nav>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { useAuthStore } from "@/stores/auth.store";
import { UserRole } from "@/enums/user-role.enum";

export default defineComponent({
  setup() {
    const authStore = useAuthStore();

    const isSuperAdmin = computed(() => authStore.user?.role === UserRole.SuperAdmin);
    const isDistributor = computed(() => authStore.user?.role === UserRole.Distributor);

    const logout = () => {
      authStore.logout();
    };

    return { authStore, isSuperAdmin, isDistributor, logout };
  }
});
</script>

<style scoped>
.sidebar {
  width: 250px;
  display: flex;
  flex-direction: column;
}

.nav-link {
  padding: 10px;
  font-size: 1rem;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>